import { Routes } from '@angular/router';
import { XeroReportComponent } from './xero-report/xero-report.component';
import { DocketStatusReportComponent } from './docket-status-report/docket-status-report.component';
import { ReportsComponent } from './reports.component';
import { PaymentsReportComponent } from './payments-report/payments-report.component';
import { OutstandingBalanceReportComponent } from './outstanding-balance-report/outstanding-balance-report.component';
import { ItemProfitibilityReportComponent } from './item-profitibility-report/item-profitibility-report.component';
import { TransportJobReportComponent } from './transport-jobs-report/transport-job-report.component';
import { BatchInvoiceReportComponent } from './batch-invoice-report/batch-invoice-report.component';
export const reportRoutes: Routes = [
  { path: '', component: ReportsComponent, title: 'Reports' },
  {
    path: 'account-transfer',
    component: XeroReportComponent,
    title: 'Account Transfer Report'
  },
  {
    path: 'dockets',
    component: DocketStatusReportComponent,
    title: 'Hire Contract Status Report'
  },
  {
    path: 'payments',
    component: PaymentsReportComponent,
    title: 'Payments Report'
  },
  {
    path: 'balance',
    component: OutstandingBalanceReportComponent,
    title: 'Outstanding Balance Report'
  },
  {
    path: 'item-profitability',
    component: ItemProfitibilityReportComponent,
    title: 'Item Profitibility Report'
  },
  {
    path: 'transport-jobs',
    component: TransportJobReportComponent,
    title: 'Transport Jobs Report'
  },
  {
    path: 'batch-invoice',
    component: BatchInvoiceReportComponent,
    title: 'Batch Invoice Report'
  }
];
